import {ViewFault} from "@docma-mm-core/fault/fault";
import {FaultData} from "@docma-mm-core/fault/fault-data";
import {Activity, ActivityData} from "@docma-mm-core/activity/activity";
import {ActivityPatchModeEnum} from "@docma-mm-core/activity/activity-patch-mode.enum";
import {Subject} from "rxjs";

export class ActivityEdit {
  faults: { [id: number]: ViewFault } = []

  changes: ActivityData;
  patchMode: ActivityPatchModeEnum;
  activities: Activity[];
}

export class ActivityEditData {
  //activityIds: number[]
  constructor(changes: ActivityData, mode: ActivityPatchModeEnum, activities?: { Id: number, UniqueId: string, Fault: FaultData}[] , activitiesOfGroup?: { Id: number, UniqueId: string, Fault: FaultData}[]) {
    //const changes = new ActivityData(activities[0]);
    this.patchData = changes;
    this.patchMode = mode;
    this.activities = activities;       //activityIds.map(m => ({ Id: m, UniqueId: null, Fault: null }));
    this.activitiesOfGroup = (activitiesOfGroup ?? []);
  }

  patchData: ActivityData;
  patchMode: ActivityPatchModeEnum;
  activities: { Id: number, UniqueId: string, Fault: FaultData }[] = [];
  activitiesOfGroup: { Id: number, UniqueId: string, Fault: FaultData }[] = [];
}

